import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import React, { Component } from "react";
import SpendingBudget from "../../widgets/SpendingBudget";
import UpcomingMonthlySpends from "../../widgets/UpcomingMonthlySpends";
import UpcomingWeeklySpends from "../../widgets/UpcomingWeeklySpends";
import PastSpendings from "../../widgets/PastSpendings";
import { getURLBase, updateParentHeight } from "../../utils/helperFns";
 
export class SpendingTab extends Component {

  constructor(props) {
    super(props);
    this.budgetUrl = getURLBase(true) + '/budgetplan';
    this.spendingUrl = getURLBase(true) + '/upcomingspend';

    this.state = {
      spendingBudgetIndex: 0,
      showAllTransaction: false,
    };
  }

  toggleTransactionScreen = () => {
    var transactionShown = this.state.showAllTransaction;
    transactionShown = !transactionShown;
    this.setState({ showAllTransaction: transactionShown },
      () => {
        updateParentHeight("parent_UpcomingWeeklySpends", "child_TransactionScreen", this.state.showAllTransaction);
      });
  };


  changeMonth = (data,index) => {
    this.setState({ spendingBudgetIndex: data.payload.weekid, showAllTransaction: false });
  }

  render() {
    return (
      <Box className="dashboard-wrapper" sx={{ flexGrow: 1 }}>
        <Grid maxWidth="md" mx={"auto"}>
          <Grid container rowGap={2} columnSpacing={2} justifyContent="center">
            <Grid item md={12} xs={12} sx={{ display: "flex" }}>
              <UpcomingMonthlySpends gid={this.props.gid} setEmbedUrl={this.props.setEmbedUrl} />
            </Grid>
            <Grid item md={12} xs={12} sx={{ display: "flex" }}>
              <SpendingBudget 
              barClickHandler={this.changeMonth} 
              gid={this.props.gid} />
            </Grid>
            <Grid item md={12} xs={12} sx={{ display: "flex" }}>
            <UpcomingWeeklySpends 
            indexId={this.state.spendingBudgetIndex}
            toggleTransactionScreen={this.toggleTransactionScreen}
            showAllTransaction={this.state.showAllTransaction}
            setEmbedUrl={this.props.setEmbedUrl}
            gid={this.props.gid}   />
            </Grid>
            <Grid item md={7} xs={12} sx={{ display: "flex" }}>
              <PastSpendings gid={this.props.gid} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default SpendingTab;
